import { render, staticRenderFns } from "./CopyBox.vue?vue&type=template&id=79f5c5ef&scoped=true"
import script from "./CopyBox.vue?vue&type=script&lang=js"
export * from "./CopyBox.vue?vue&type=script&lang=js"
import style0 from "./CopyBox.vue?vue&type=style&index=0&id=79f5c5ef&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79f5c5ef",
  null
  
)

export default component.exports